import { RatioFormatType, RatioFormatObject } from 'types/RatioFormat';

export enum TargetSettingsAspectRatioEnum {
  Ratio11 = '1:1',
  Ratio916 = '9:16',
  Ratio45 = '4:5',
  Ratio169 = '16:9'
}

export const FORM_FACTORS = {
  [TargetSettingsAspectRatioEnum.Ratio11]: {
    ratio: 1,
    ratioText: TargetSettingsAspectRatioEnum.Ratio11,
    sizeText: '1080 x 1080 px',
    width: 70
  },
  [TargetSettingsAspectRatioEnum.Ratio916]: {
    ratio: 9 / 16,
    ratioText: TargetSettingsAspectRatioEnum.Ratio916,
    sizeText: '1080 x 1920 px',
    width: 40
  },
  [TargetSettingsAspectRatioEnum.Ratio45]: {
    ratio: 4 / 5,
    ratioText: TargetSettingsAspectRatioEnum.Ratio45,
    sizeText: '1080 x 1350 px',
    width: 70
  },
  [TargetSettingsAspectRatioEnum.Ratio169]: {
    ratio: 16 / 9,
    ratioText: TargetSettingsAspectRatioEnum.Ratio169,
    sizeText: '1920 x 1080 px',
    width: 100
  }
};

export const ratioFormats: { [x in RatioFormatType]: RatioFormatObject } = {
  [RatioFormatType.Youtube]: {
    icon: 'youtube-cover-social',
    ratioFormatType: RatioFormatType.Youtube,
    titleText: 'YouTube',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio169]
  },
  [RatioFormatType.InstagramPortrait]: {
    icon: 'instagram-portrait-social',
    ratioFormatType: RatioFormatType.InstagramPortrait,
    titleText: 'Instagram_Portrait',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio45]
  },
  [RatioFormatType.InstagramSquare]: {
    icon: 'instagram-profile-social',
    ratioFormatType: RatioFormatType.InstagramSquare,
    titleText: 'Instagram_Square',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio11]
  },
  [RatioFormatType.InstagramStory]: {
    icon: 'instagram-story-social',
    ratioFormatType: RatioFormatType.InstagramStory,
    titleText: 'Instagram_Story',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio916]
  },
  [RatioFormatType.FacebookPortrait]: {
    icon: 'facebook-portrait-social',
    ratioFormatType: RatioFormatType.FacebookPortrait,
    titleText: 'Facebook_Portrait',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio45]
  },
  [RatioFormatType.FacebookSquare]: {
    icon: 'facebook-profile-social',
    ratioFormatType: RatioFormatType.FacebookSquare,
    titleText: 'Facebook_Square',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio11]
  },
  [RatioFormatType.FacebookStory]: {
    icon: 'facebook-story-social',
    ratioFormatType: RatioFormatType.FacebookStory,
    titleText: 'Facebook_Story',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio916]
  },
  [RatioFormatType.Tiktok]: {
    icon: 'tiktok-social',
    ratioFormatType: RatioFormatType.Tiktok,
    titleText: 'Tik-Tok',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio916]
  },
  [RatioFormatType.Snapchat]: {
    icon: 'snapchat-social',
    ratioFormatType: RatioFormatType.Snapchat,
    titleText: 'Snapchat',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio916]
  },
  [RatioFormatType.Twitter]: {
    icon: 'twitter-portrait-social',
    ratioFormatType: RatioFormatType.Twitter,
    titleText: 'Twitter_Portrait',
    ...FORM_FACTORS[TargetSettingsAspectRatioEnum.Ratio45]
  }
};
